import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { DataLakeTables } from "@graylog/enterprise-api";
import useFeature from "hooks/useFeature";
import { defaultOnError } from "util/conditional/onError";
import { defaultCompare } from "logic/DefaultCompare";
const fetchDataLakeTables = (dataLakeId) => DataLakeTables.listTables(dataLakeId).then(
  (tables = []) => tables.sort((t1, t2) => {
    if (t1.catalog !== t2.catalog) {
      return defaultCompare(t1.catalog, t2.catalog);
    }
    if (t1.schema !== t2.schema) {
      return defaultCompare(t1.schema, t2.schema);
    }
    return defaultCompare(t1.name, t2.name);
  })
);
const useDataLakeTables = (dataLakeId) => {
  const featureIsEnabled = useFeature("external_data_lake_search");
  const { data = [], isLoading } = useQuery({
    queryKey: ["data-lake", "external-tables", dataLakeId],
    queryFn: () => defaultOnError(
      fetchDataLakeTables(dataLakeId),
      i18n.t("notifications.fetch_table_options_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_table_options_failed_title", { ns: "enterprise_data_lake" })
    ),
    enabled: featureIsEnabled && !!dataLakeId
  });
  return {
    data,
    isLoading
  };
};
export default useDataLakeTables;
